export const BOOKING_ADD_ITEM = "BOOKING_ADD_ITEM";
export const BOOKING_REMOVE_ITEM = "BOOKING_REMOVE_ITEM";
export const BOOKING_SAVE_DELIVERY_ADDRESS = "BOOKING_SAVE_SHIPPING_ADDRESS";
export const BOOKING_SAVE_PAYMENT_METHOD = "BOOKING_SAVE_PAYMENT_METHOD";
